import { useEffect, useState } from "react";

function SitePurchasePage() {
  const [sites, setSites] = useState([]);

  useEffect(() => {
    fetch("process.env.REACT_APP_API_URL/sites")
      .then(res => res.json())
      .then(data => setSites(data));
  }, []);

  return (
    <div style={{ padding: "25px" }}>
      <h2>🏗️ Site Purchase</h2>
      <MaterialForm sites={sites} />
    </div>
  );
}

export default SitePurchasePage;



// ================= MATERIAL FORM =================

function MaterialForm({ sites }) {
  const [list, setList] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [form, setForm] = useState({
    site_id: "",
    amount: "",
    payment_mode: "",
    paid_by: "",
    remarks: "",
    item_type: [],
    image: null
  });

  // 🔹 LOAD DATA
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const res = await fetch("process.env.REACT_APP_API_URL/site-purchases");
    const data = await res.json();

    const materialOnly = data.filter(d => d.category === "material");
    setList(materialOnly);
  };
  const handleDelete = async (id) => {
  if (!window.confirm("Delete this item?")) return;

  await fetch(`process.env.REACT_APP_API_URL/site-purchase/${id}`, {
    method: "DELETE"
  });

  alert("Deleted ✅");
  loadData();
};
const handleEdit = (row) => {
  setForm({
    site_id: row.site_id,
    amount: row.amount,
    payment_mode: row.payment_mode || "",
    paid_by: row.paid_by || "",
    remarks: row.remarks || "",
    item_type: row.extra_data?.item_type || [],
    image: null
  });

  setEditingId(row.id);

  window.scrollTo({ top: 0, behavior: "smooth" });
};

  // 🔹 MULTI SELECT
  const toggleItem = (type) => {
    setForm(prev => ({
      ...prev,
      item_type: prev.item_type.includes(type)
        ? prev.item_type.filter(t => t !== type)
        : [...prev.item_type, type]
    }));
  };

  // 🔹 SUBMIT
const handleSubmit = async () => {
  if (!form.site_id || !form.amount) {
    alert("Required fields missing ❗");
    return;
  }

  const extra_data = {
    item_type: form.item_type
  };

  if (editingId) {
    // 🔥 UPDATE
    await fetch(`process.env.REACT_APP_API_URL/site-purchase/${editingId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        site_id: form.site_id,
        amount: form.amount,
        payment_mode: form.payment_mode,
        paid_by: form.paid_by,
        remarks: form.remarks,
        extra_data
      })
    });

    alert("Updated ✅");
    setEditingId(null);

  } else {
    // 🔥 INSERT (your existing FormData logic)
    const data = new FormData();

    data.append("site_id", form.site_id);
    data.append("category", "material");
    data.append("amount", form.amount);
    data.append("payment_mode", form.payment_mode);
    data.append("paid_by", form.paid_by);
    data.append("remarks", form.remarks);
    data.append("extra_data", JSON.stringify(extra_data));

    if (form.image) {
      data.append("image", form.image);
    }

    await fetch("process.env.REACT_APP_API_URL/site-purchase", {
      method: "POST",
      body: data
    });

    alert("Saved ✅");
  }

  loadData();
};
  const input = {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    width: "100%"
  };

  return (
    <div style={{
      background: "#fff",
      padding: "20px",
      borderRadius: "10px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
    }}>
      <h3>Material Purchase</h3>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(2,1fr)",
        gap: "10px"
      }}>

        {/* SITE */}
        <select
          value={form.site_id}
          onChange={(e) => setForm({ ...form, site_id: e.target.value })}
          style={input}
        >
          <option value="">Select Site</option>
          {sites.map(s => (
            <option key={s.id} value={s.id}>{s.site_name}</option>
          ))}
        </select>

        {/* AMOUNT */}
        <input
          type="number"
          placeholder="Amount"
          value={form.amount}
          onChange={(e) => setForm({ ...form, amount: e.target.value })}
          style={input}
        />

        {/* ITEM TYPE */}
        <div style={{ gridColumn: "span 2" }}>
          <b>Item Type:</b><br />
          {["civil","electrical","plumbing","carpenter","other"].map(type => (
            <label key={type} style={{ marginRight: "10px" }}>
              <input
                type="checkbox"
                checked={form.item_type.includes(type)}
                onChange={() => toggleItem(type)}
              />
              {type}
            </label>
          ))}
        </div>

        {/* PAYMENT MODE */}
        <select
          value={form.payment_mode}
          onChange={(e) => setForm({ ...form, payment_mode: e.target.value })}
          style={input}
        >
          <option value="">Payment Mode</option>
          <option value="cash">Cash</option>
          <option value="gpay">GPay</option>
        </select>

        {/* PAID BY */}
        <select
          value={form.paid_by}
          onChange={(e) => setForm({ ...form, paid_by: e.target.value })}
          style={input}
        >
          <option value="">Paid By</option>
          <option value="accountant">Accountant</option>
          <option value="supervisor">Supervisor</option>
        </select>

        {/* REMARKS */}
        <textarea
          placeholder="Remarks"
          value={form.remarks}
          onChange={(e) => setForm({ ...form, remarks: e.target.value })}
          style={{ ...input, gridColumn: "span 2" }}
        />

        {/* IMAGE */}
        <input
          type="file"
          onChange={(e) => setForm({ ...form, image: e.target.files[0] })}
        />

        {/* SAVE */}
        <button
          onClick={handleSubmit}
          style={{
            gridColumn: "span 2",
            padding: "12px",
            background: "#2563eb",
            color: "#fff",
            border: "none",
            borderRadius: "6px"
          }}
        >
          Save Material
        </button>
      </div>

      {/* 🔥 TABLE */}
      <h3 style={{ marginTop: "20px" }}>Material List</h3>

      <table style={{ width: "100%", marginTop: "10px" }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Site</th>
            <th>Amount</th>
            <th>Item</th>
            <th>Image</th>
          </tr>
        </thead>

        <tbody>
          {list.map(row => (
            <tr key={row.id}>
              <td>{row.id}</td>
              <td>{row.site_name}</td>
              <td>₹ {row.amount}</td>
              <td>{row.extra_data?.item_type?.join(", ")}</td>
              <td>
                {row.image && (
                  <img
                    src={`process.env.REACT_APP_API_URL/uploads/${row.image}`}
                    width="50"
                  />
                )}
              </td>
              <td>
  <button onClick={() => handleEdit(row)}>Edit</button>
  <button onClick={() => handleDelete(row.id)}>Delete</button>
</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}